<template>
  <div>
    <home-swiper :list="swiperList" v-transition></home-swiper>
    <home-headline :list="headlineList" v-transition></home-headline>
    <home-icons v-transition></home-icons>
    <home-classify :list="classifyList" v-transition></home-classify>
    <home-recommended :list="recommendedList" v-transition></home-recommended>
    <home-lastest :list="lastestList" v-transition></home-lastest>
    <home-footer v-transition></home-footer>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import HomeSwiper from './components/Swiper'
import HomeHeadline from './components/Headline'
import HomeIcons from './components/Icons'
import HomeClassify from './components/Classify'
import HomeRecommended from './components/Recommended'
import HomeLastest from './components/Lastest'
import HomeFooter from './components/Footer'
export default {
  name: 'Home',
  components: {
    HomeSwiper,
    HomeHeadline,
    HomeIcons,
    HomeClassify,
    HomeRecommended,
    HomeLastest,
    HomeFooter
  },
  data () {
    return {
      swiperList: [],
      recommendedList: [],
      lastestList: [],
      classifyList: [],
      headlineList: []
    }
  },
  methods: {
    getHomeInfo () {
      this.axios.get('/ApiHome/GetSynthetic')
        .then(this.getHomeInfoSucc)
        .catch(this.getHomeInfoFail)
    },
    getHomeInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.swiperList = JSON.parse(data.swiperList)
        this.recommendedList = JSON.parse(data.recommendedList)
        this.classifyList = JSON.parse(data.classifyList)
        this.headlineList = JSON.parse(data.headlineList)
        Indicator.close()
      } else {
        Indicator.close()
        Toast({
          message: '加载超时',
          position: 'middle',
          duration: 3000
        })
      }
    },
    getHomeInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getHomeInfo()
    Indicator.open({
      text: 'Loading...',
      spinnerType: 'fading-circle'
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/Home.vue